import { useCallback, useEffect, useState } from 'react';
import {
  GetAdminOnboardingTemplatesAPI,
  SaveAdminOnboardingTemplateAPI,
  SetAdminOnboardingSequenceAPI,
} from '../../../../api/AdminAPI';

/**
 * useOnboardingTemplates
 *
 * Modelos dos e-mails de acompanhamento com os números, a chave geral e as listas fixas
 * do editor (etapas, destinos do botão, variáveis).
 *
 * @param {Function} notify - (message, severity) mostra o aviso da tela
 */
function useOnboardingTemplates(notify) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSavingSequence, setIsSavingSequence] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    GetAdminOnboardingTemplatesAPI((response) => {
      setLoading(false);
      if (!response || response.success === false) {
        setError(response?.error || 'Não foi possível carregar os e-mails de acompanhamento.');
        return;
      }
      setError(null);
      setData(response);
    });
  }, []);

  useEffect(() => { load(); }, [load]);

  const setSequenceEnabled = useCallback((enabled) => {
    setIsSavingSequence(true);
    SetAdminOnboardingSequenceAPI(enabled, (response) => {
      setIsSavingSequence(false);
      if (!response || response.success === false) {
        notify(response?.error || 'Não foi possível mudar a chave geral.', 'error');
        return;
      }
      setData((prev) => (prev ? { ...prev, settings: response.settings } : prev));
      notify(enabled ? 'Sequência ligada.' : 'Sequência desligada.', 'success');
    });
  }, [notify]);

  /** Grava o modelo; onDone(ok, template) no fim. */
  const saveTemplate = useCallback((template, onDone) => {
    SaveAdminOnboardingTemplateAPI(template, (response) => {
      if (!response || response.success === false) {
        notify(response?.error || 'Não foi possível salvar o modelo.', 'error');
        if (onDone) onDone(false, null);
        return;
      }
      setData((prev) => (prev ? {
        ...prev,
        templates: prev.templates.map((item) => (item.key === response.template.key ? { ...item, ...response.template, stats: item.stats } : item)),
      } : prev));
      notify('Modelo salvo.', 'success');
      if (onDone) onDone(true, response.template);
    });
  }, [notify]);

  return { data, loading, error, reload: load, setSequenceEnabled, isSavingSequence, saveTemplate };
}

export default useOnboardingTemplates;
